import { brandedInteger } from '../brand'
import type { Branded } from '../brand'

/** Integer pence, GBP only. Ceiling is 2^53 pence (~£90 trillion). */
export type Pence = Branded<number, 'Pence'>
/** Integer basis points. 20% = 2000. */
export type BasisPoints = Branded<number, 'BasisPoints'>
export type Wp = Branded<number, 'Wp'>
export type Millilitres = Branded<number, 'Millilitres'>
export type Minutes = Branded<number, 'Minutes'>
export type Count = Branded<number, 'Count'>

const PenceBrand = brandedInteger('Pence')
const BasisPointsBrand = brandedInteger('BasisPoints', { min: 0 })
const WpBrand = brandedInteger('Wp', { min: 0 })
const MillilitresBrand = brandedInteger('Millilitres', { min: 0 })
const MinutesBrand = brandedInteger('Minutes', { min: 0 })
const CountBrand = brandedInteger('Count', { min: 0 })

export const asPence = PenceBrand.of
export const asBasisPoints = BasisPointsBrand.of
export const asWp = WpBrand.of
export const asMillilitres = MillilitresBrand.of
export const asMinutes = MinutesBrand.of
export const asCount = CountBrand.of

export const isPence = PenceBrand.is
export const isBasisPoints = BasisPointsBrand.is
export const isWp = WpBrand.is
export const isMillilitres = MillilitresBrand.is
export const isMinutes = MinutesBrand.is
export const isCount = CountBrand.is
